import type { ReactNode } from 'react';
import { Label } from '@vnetwork/ui/primitives';

/** A single label/value pair. `full` spans the whole row. */
export interface InfoItem {
  label: ReactNode;
  value: ReactNode;
  full?: boolean;
}

/**
 * Responsive label/value grid for detail pages (profile, account info). Pure
 * tokens; auto-fits columns and lets an item span the full width. Empty values
 * render an em dash.
 */
export function InfoGrid({ items, minColWidth = 220 }: { items: InfoItem[]; minColWidth?: number }) {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(${minColWidth}px, 1fr))`,
        gap: 'var(--vn-space-4)',
      }}
    >
      {items.map((item, i) => (
        <div
          key={i}
          style={{
            display: 'grid',
            gap: 'var(--vn-space-1)',
            minWidth: 0,
            gridColumn: item.full ? '1 / -1' : undefined,
          }}
        >
          <Label style={{ textTransform: 'uppercase', letterSpacing: '0.02em', fontSize: 'var(--vn-font-size-xs)' }}>
            {item.label}
          </Label>
          <span
            style={{
              fontSize: 'var(--vn-font-size-sm)',
              color: 'var(--vn-fg-default)',
              fontWeight: 'var(--vn-font-weight-medium)',
              overflowWrap: 'anywhere',
            }}
          >
            {item.value === null || item.value === undefined || item.value === '' ? '—' : item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
